module.exports = __webpack_public_path__ + "Gabriel_Musso_Web_Over.jpg?5c22399a32d7ee028892464ac6c29b36";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Gabriel_Musso_Web_Over.jpg
// module id = 169
// module chunks = 0